import {
  GET_DEFAULT_ASSIGNMENT_FAIL,
  GET_DEFAULT_ASSIGNMENT_SUCCESS,
  GET_DEFAULT_ASSIGNMENTS_FAIL,
  GET_DEFAULT_ASSIGNMENTS_SUCCESS,
  ADD_DEFAULT_ASSIGNMENT_SUCCESS,
  ADD_DEFAULT_ASSIGNMENT_FAIL,
  UPDATE_DEFAULT_ASSIGNMENT_SUCCESS,
  UPDATE_DEFAULT_ASSIGNMENT_FAIL,
  DELETE_DEFAULT_ASSIGNMENT_SUCCESS,
  DELETE_DEFAULT_ASSIGNMENT_FAIL,  
  SET_STATE_DEFAULT_ASSIGNMENT
} from "./actionTypes";

const INIT_STATE = {
  defaultAssignments: [],
  defaultAssignment: {},
  error: {},
  loading: false,
  total: 0,
  currentPage: 0,
};

const defaultAssignments = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_DEFAULT_ASSIGNMENTS_SUCCESS:
      return {
        ...state,
        defaultAssignments: action.payload.defaultAssignments,
        total: action.payload.total,
        currentPage: action.payload.currentPage,
      };

    case SET_STATE_DEFAULT_ASSIGNMENT:
      return { ...state, loading: action.payload }

    case GET_DEFAULT_ASSIGNMENTS_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case ADD_DEFAULT_ASSIGNMENT_SUCCESS:
      return {
        ...state,
        defaultAssignments: [...state.defaultAssignments, action.payload],
      };

    case ADD_DEFAULT_ASSIGNMENT_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case UPDATE_DEFAULT_ASSIGNMENT_SUCCESS:
      return {
        ...state,
        defaultAssignments: state.defaultAssignments.map(item =>
          item.id.toString() === action.payload.id.toString()
            ? { ...action.payload, ...item }
            : item
        ),
      };

    case UPDATE_DEFAULT_ASSIGNMENT_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case DELETE_DEFAULT_ASSIGNMENT_SUCCESS:
      return {
        ...state,
        defaultAssignments: state.defaultAssignments.filter(
          item => item.id.toString() !== action.id.toString()
        ),
      };

    case DELETE_DEFAULT_ASSIGNMENT_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case GET_DEFAULT_ASSIGNMENT_SUCCESS:
      return {
        ...state,
        defaultAssignment: action.payload,
      };

    case GET_DEFAULT_ASSIGNMENT_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default defaultAssignments;
